// Generated by CoffeeScript 2.3.2

import AppBar from '@material-ui/core/AppBar';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import React, { Component } from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
;
var CardChoices, CardList, GroupedCardList, MultipleCardChooser,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } },
  indexOf = [].indexOf;

GroupedCardList = function(props) {
  var cards, id, selected, type;
  ({selected, type, cards} = props);
  return <ul>
    {(function() {
    var i, len, results;
    results = [];
    for (i = 0, len = selected.length; i < len; i++) {
      id = selected[i];
      if (cards[id].type === type) {
        results.push(<li key={id}> {cards[id].name} </li>);
      }
    }
    return results;
  })()}
  </ul>;
};

CardList = function(props) {
  var cards, selected, typeId, types, value;
  ({selected, cards, types} = props);
  return <ul>
    {(function() {
    var results;
    results = [];
    for (typeId in types) {
      value = types[typeId];
      results.push(<li key={typeId}>
          <b>{value.title}</b>
          <GroupedCardList selected={selected} type={typeId} cards={cards} />
        </li>);
    }
    return results;
  })()}
  </ul>;
};

CardChoices = class CardChoices extends Component {
  constructor() {
    super(...arguments);
    this.makeChangeHandler = this.makeChangeHandler.bind(this);
  }

  makeChangeHandler(id) {
    boundMethodCheck(this, CardChoices);
    return (event) => {
      return this.props.onChange(id, event.target.checked);
    };
  }

  render() {
    var cards, excluded, id, info, type, value;
    ({value, cards, excluded, type} = this.props);
    return <FormGroup row>
      {(function() {
      var results;
      results = [];
      for (id in cards) {
        info = cards[id];
        if (info.type === type) {
          results.push(<FormControlLabel key={id} control={<Checkbox checked={indexOf.call(value, id) >= 0} disabled={(excluded != null) && indexOf.call(excluded, id) >= 0} onChange={this.makeChangeHandler(id)} value={id} />} label={info.name} />);
        }
      }
      return results;
    }).call(this)}
    </FormGroup>;
  }

};

MultipleCardChooser = class MultipleCardChooser extends Component {
  constructor(props) {
    super(props);
    this.handleChangeTab = this.handleChangeTab.bind(this);
    this.state = {
      currentTab: 0
    };
    return;
  }

  handleChangeTab(event, currentTab) {
    boundMethodCheck(this, MultipleCardChooser);
    this.setState({currentTab});
  }

  render() {
    var cards, excluded, id, onChange, tabId, tabIds, tabIndex, types, value;
    ({value, cards, types, excluded, onChange} = this.props);
    tabIds = (function() {
      var results;
      results = [];
      for (id in types) {
        results.push(id);
      }
      return results;
    })();
    tabIndex = this.state.currentTab >= 0 && this.state.currentTab < tabIds.length ? this.state.currentTab : 0;
    tabId = tabIds[tabIndex];
    return <div>
      <AppBar position="static">
        <Tabs value={tabIndex} onChange={this.handleChangeTab}>
          {(function() {
      var i, len, results;
      results = [];
      for (i = 0, len = tabIds.length; i < len; i++) {
        id = tabIds[i];
        results.push(<Tab key={id} label={types[id].title} />);
      }
      return results;
    })()}
        </Tabs>
      </AppBar>
      <CardChoices value={value} cards={cards} excluded={excluded} type={tabId} onChange={onChange} />
      <b>Selected Cards:</b>
      <CardList selected={value} cards={cards} types={types} />
    </div>;
  }

};

export default MultipleCardChooser;
